<template>
  <div>
    <div class="text-center">
      <el-button-group>
        <el-button
          size="mini"
          :type="isShowBackgroundJobs ? 'primary' : ''"
          @click.native="() => { isShowBackgroundJobs = true }"
        >
          <FontAwesomeIcon :icon="['fal', 'microchip']" />
          Background Jobs
        </el-button>
        <el-button
          size="mini"
          :type="isShowBackgroundJobs ? '' : 'primary'"
          @click.native="() => { isShowBackgroundJobs = false }"
        >
          <FontAwesomeIcon :icon="['fal', 'comments-alt']" />
          Notifications
        </el-button>
      </el-button-group>
    </div>
    <br>
    <div
      v-if="isShowBackgroundJobs"
      class="mb-2"
      style="display: flex; justify-content: space-between; align-items: start;"
    >
      <h2>Background Jobs</h2>
      <el-button
        size="mini"
        @click.native="$refs.component.loadBackgroundJobs()"
      >
        <FontAwesomeIcon
          :icon="['fal', 'sync']"
        />
      </el-button>
    </div>
    <div
      v-else
      class="mb-2"
      style="display: flex; justify-content: space-between; align-items: start;"
    >
      <h2>Notifications</h2>
      <el-button
        size="mini"
        @click.native="$refs.component.loadNotifications()"
      >
        <FontAwesomeIcon
          :icon="['fal', 'sync']"
        />
      </el-button>
    </div>
    <component
      :is="component"
      ref="component"
    />
  </div>
</template>

<script>
import BackgroundJobs from '@/components/Navigation/Topbar/BackgroundJobs'
import Notifications from '@/components/Navigation/Topbar/Notifications'

export default {
  components: {
    BackgroundJobs,
    Notifications
  },
  data () {
    return {
      isShowBackgroundJobs: true
    }
  },
  computed: {
    component () {
      return this.isShowBackgroundJobs ? BackgroundJobs : Notifications
    }
  }
}
</script>
